import React from 'react';
import { Button, ButtonGroup, CssBaseline, Grid } from '@material-ui/core';

import Topbar from '../components/Topbar';
import Footer from '../components/Footer';
import Container from '../components/Div/Container';
import MainTitle from '../components/Text/MainTitle';
// import Preparing from '../components/Preparing';
// import InternationalSpeakers from './InternationalSpeakers';
import InternationalSpeakersKoreaCopy from './InternationalSpeakersKoreaCopy';
import InternationalSpeakers from './InternationalSpeakersCopy';

class InvitedSpeakers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tabValue: 0,
    };

    this.handleState = this.handleState.bind(this);
  }

  handleState(key, value) {
    this.setState({ [key]: value });
  }

  render() {
    const { tabValue } = this.state;
    return (
      <div>
        <CssBaseline />
        <Topbar MIdx={1} SIdx={2} />
        <Container>
          <Grid container justifyContent={'center'}>
            <Grid item xs={8}>
              <MainTitle>Invited Speakers</MainTitle>
            </Grid>
            <Grid item xs={8}>
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                <ButtonGroup color="primary" fullWidth disableElevation style={{ width: '80%' }}>
                  <Button
                    variant={tabValue === 0 ? 'contained' : 'outlined'}
                    onClick={() => this.handleState('tabValue', 0)}
                    style={{ fontSize: 'large' }}
                  >
                    Korean
                  </Button>
                  <Button
                    variant={tabValue === 1 ? 'contained' : 'outlined'}
                    onClick={() => this.handleState('tabValue', 1)}
                    style={{ fontSize: 'large' }}
                  >
                    International
                  </Button>
                </ButtonGroup>
              </div>
            </Grid>
            <Grid item xs={8}>
              <div style={{ margin: '3em 0' }}>
                {/* 2022 CUSTOM :: 본 행사 연자정보 적용 */}
                {tabValue === 0 && <InternationalSpeakersKoreaCopy />}
                {tabValue === 1 && <InternationalSpeakers />}
                {/* {tabValue === 0 && <Preparing />}
                {tabValue === 1 && <Preparing />} */}
              </div>
            </Grid>
          </Grid>
        </Container>
        <Footer />
      </div>
    );
  }
}

export default InvitedSpeakers;
